 <div class="pop-up-mask" id="pop-up-mask" [class.shown]="isOpen">
  <div class="pop-up-outer">
    <div class="pop-up-inner">
      <div class="pop-up-box" [class.title]="title">
        <ng-container *ngIf="title && !dcdArticle">
          <div class="heading">
            {{ title }}
          </div>
          <div class="text">
            <p *ngIf="!balanceText" [innerHtml]="message | parseFormattedText"></p>
            <p *ngIf="balanceText" [innerHtml]="message | parseFormattedText" ngxBalanceText></p>
          </div>
          <div class="footer">
            <button *ngIf="!!callback" (click)="clickHandler()">{{ confirmText }}</button>
            <button *ngIf="!callback" (click)="close()">{{ locale.closeButton }}</button>
          </div>
        </ng-container>

        <ng-container *ngIf="dcdArticle">
          <div class="heading">
            {{ title }}
          </div>
          <div class="text left-align" *ngIf="dcdArticle.introduction">
            <h3>Introduction</h3>
            <p [innerHtml]="dcdArticle.introduction | parseFormattedText"></p>
          </div>
          <div class="text left-align" *ngIf="dcdArticle.degree_courses">
            <h3>Degree Courses</h3>
            <p [innerHtml]="dcdArticle.degree_courses | parseFormattedText"></p>
          </div>
          <div class="text left-align" *ngIf="dcdArticle.opportunities">
            <h3>Opportunities</h3>
            <p [innerHtml]="dcdArticle.opportunities | parseFormattedText"></p>
          </div>
          <div class="text left-align" *ngIf="dcdArticle.related_degrees">
            <h3>Related Degrees</h3>
            <p [innerHtml]="dcdArticle.related_degrees | parseFormattedText"></p>
          </div>
          <div class="text left-align" *ngIf="dcdArticle.readings.length">
            <h3>Suggested Reading</h3>
            <ul>
              <li class="reading" *ngFor="let reading of dcdArticle.readings">
                {{ reading.title }}
                <p *ngIf="reading.author">
                  - {{ reading.author }} {{ reading.publisher ? ', ' + reading.publisher : '' }} {{ reading.published_at ? ', ' + reading.published_at : '' }}
                </p>
                <p *ngIf="reading.notes" [innerHtml]="reading.notes" ></p>
              </li>
            </ul>
          </div>
          <div class="text left-align" *ngIf="dcdArticle.websites.length">
            <h3>Further Information</h3>
            <ul>
              <li *ngFor="let website of dcdArticle.websites">
                <a target="_blank" href="{{ website.url }}">{{ website.title }}</a>
              </li>
            </ul>
          </div>
          <div class="text left-align" *ngIf="dcdArticle.checklist_items.length">
            <h3>Course Check</h3>
            <checklist
              [checklistId]="dcdArticle.id"
              [items]="dcdArticle.checklist_items"
            >
            </checklist>
          </div>
          <div class="footer">
            <button *ngIf="!!callback" (click)="clickHandler()">{{ confirmText }}</button>
            <button *ngIf="!callback" (click)="close()">{{ locale.closeButton }}</button>
          </div>
        </ng-container>

        <ng-container *ngIf="youtubeURL">
          <iframe
            title="Video"
            width="100%"
            [src]="youtubeURL"
            allow="autoplay; encrypted-media"
            allowfullscreen
          >
          </iframe>
        </ng-container>

        <div class="close-bn">
          <a (click)="close()">{{ locale.closeButton }}</a>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/components/_shared/modal/modal.component.html